var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _vm.popupParam.targetClassCd === "1"
              ? _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-dept", {
                      attrs: { label: "부서", name: "deptCd" },
                      model: {
                        value: _vm.searchParam.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "deptCd", $$v)
                        },
                        expression: "searchParam.deptCd",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.popupParam.targetClassCd === "2"
              ? _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        editable: _vm.editable,
                        comboItems: _vm.eduPositionItems,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "직책",
                        name: "positionCd",
                      },
                      model: {
                        value: _vm.searchParam.positionCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "positionCd", $$v)
                        },
                        expression: "searchParam.positionCd",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.popupParam.targetClassCd === "3"
              ? _c(
                  "div",
                  {
                    staticClass: "col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        editable: _vm.editable,
                        comboItems: _vm.eduSeniorItems,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "법규/선임",
                        name: "seniorCd",
                      },
                      model: {
                        value: _vm.searchParam.seniorCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "seniorCd", $$v)
                        },
                        expression: "searchParam.seniorCd",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "대상자 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            selection: _vm.popupParam.type,
            usePaging: false,
            cardClass: "topcolor-orange",
            rowKey: "seq",
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _c("c-btn", {
                    attrs: { label: "선택", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }